import type { LineGroupProps } from '@Components/BigBrowse/Utils/LineGroupComponent';
import { LineGroup } from '@Components/BigBrowse/Utils/LineGroupComponent';
import type { Vector3 } from '@react-three/fiber';
import { THREE } from 'expo-three';
import type { FC } from 'react';

const lines: Vector3[][] = [
  [new THREE.Vector3(-20, 0, 0), new THREE.Vector3(21, 0, 0)], // horizontal line
  [new THREE.Vector3(16, 5, 0), new THREE.Vector3(21, 0, 0)], // upper-notch
  [new THREE.Vector3(16, -5, 0), new THREE.Vector3(21, 0, 0)], // lower-notch
];

type Props = Omit<LineGroupProps, 'lines'> & object;

export const ArrowRight: FC<Props> = (props) => (
  <LineGroup lines={lines} {...props} />
);
